export const NEWS_ROUTES = {
  list: '/news/',
  detail: (slug: string) => `/news/${slug}/`,
} as const

/** Размер превью новостей на главной */
export const HOME_NEWS_PREVIEW_SIZE = 4

/** Кол-во новостей на странице списка */
export const NEWS_PAGE_SIZE = {
  mobile: 6,
  desktop: 12,
} as const

export const NEWS_LIST_SEO = {
  title: 'Новости - Farfor',
  description:
    'Важные новости и приятные акции от доставки суши и пиццы Farfor: узнавайте больше, заказывайте чаще',
} as const

export const NEWS_FALLBACK_TITLE = 'Новости'
